import { render, staticRenderFns } from "./DictionaryStandardEffects.vue?vue&type=template&id=5b98980c&scoped=true&"
import script from "./DictionaryStandardEffects.vue?vue&type=script&lang=js&"
export * from "./DictionaryStandardEffects.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryStandardEffects.vue?vue&type=style&index=0&id=5b98980c&scoped=true&lang=scss&"
import style1 from "./DictionaryStandardEffects.vue?vue&type=style&index=1&id=5b98980c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b98980c",
  null
  
)

export default component.exports